import { useEffect, useRef } from "react";

const HOVER_SELECTOR = 'a, button, [role="button"], [data-cursor="hover"]';

const CustomCursor = () => {
    const dotRef = useRef<HTMLDivElement>(null);
    const ringRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (typeof window === "undefined") return;

        if (window.matchMedia("(hover: none)").matches) return;

        const dot = dotRef.current;
        const ring = ringRef.current;
        if (!dot || !ring) return;

        let mx = window.innerWidth / 2;
        let my = window.innerHeight / 2;
        let rx = mx;
        let ry = my;
        let raf = 0;
        let hovering = false;

        const onMove = (e: MouseEvent) => {
            mx = e.clientX;
            my = e.clientY;
            dot.style.transform = `translate3d(${mx - 4}px, ${my - 4}px, 0)`;

            const el = e.target as Element | null;
            const hit = !!el?.closest(HOVER_SELECTOR);
            if (hit !== hovering) {
                hovering = hit;
                ring.dataset.hover = hit ? "1" : "0";
            }
        };

        const tick = () => {
            rx += (mx - rx) * 0.18;
            ry += (my - ry) * 0.18;
            ring.style.transform = `translate3d(${rx - 20}px, ${ry - 20}px, 0)`;
            raf = requestAnimationFrame(tick);
        };

        window.addEventListener("mousemove", onMove, { passive: true });
        raf = requestAnimationFrame(tick);
        document.documentElement.classList.add("has-custom-cursor");

        return () => {
            window.removeEventListener("mousemove", onMove);
            cancelAnimationFrame(raf);
            document.documentElement.classList.remove("has-custom-cursor");
        };
    }, []);

    return (
        <>
            <div
                ref={dotRef}
                aria-hidden
                className="pointer-events-none fixed top-0 left-0 z-[9999] w-2 h-2 rounded-full hidden lg:block"
                style={{
                    background: "hsl(260 100% 75%)",
                    boxShadow: "0 0 12px hsl(260 100% 70%), 0 0 28px hsl(260 100% 60% / 0.6)",
                    willChange: "transform",
                }}
            />
            <div
                ref={ringRef}
                aria-hidden
                data-hover="0"
                className="pointer-events-none fixed top-0 left-0 z-[9998] w-10 h-10 rounded-full hidden lg:block transition-[width,height,background,border-color] duration-300 ease-[cubic-bezier(.23,1,.32,1)] data-[hover=1]:w-[72px] data-[hover=1]:h-[72px] data-[hover=1]:border-[hsl(190_100%_70%_/_0.9)] data-[hover=1]:bg-[hsl(260_100%_70%_/_0.08)]"
                style={{
                    border: "1px solid hsl(260 100% 75% / 0.6)",
                    willChange: "transform",
                }}
            />
        </>
    );
};

export default CustomCursor;
